import { measurementTypeForMeasurement } from "@RHCommerceDev/resources/countries-config.json";
import useUserPreferences from "@RHCommerceDev/hooks/useUserPreferences";

const useMeasurementType = () => {
  const { previousState } = useUserPreferences();
  return measurementTypeForMeasurement[previousState?.measurement];
};

export default useMeasurementType;
